module.exports = __webpack_public_path__ + "img/HTML.d465be46.svg";